// src/components/SettingsDashboard.js
import React from 'react';

export default function SettingsDashboard({
    hotelSettings,
    setHotelSettings,
    handleSaveSettings,
    loading,
}) {
    // Handler for general settings changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setHotelSettings(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
            <h2>Hotel & Guest App Settings ⚙️</h2>
            <p style={{ color: '#555', borderBottom: '1px solid #eee', paddingBottom: '10px', marginBottom: '20px' }}>
                Configure global settings that affect the guest mobile application and staff workflows.
            </p>

            <form onSubmit={handleSaveSettings}>
                <div style={{ marginBottom: '30px', padding: '15px', border: '1px solid #ddd', borderRadius: '6px' }}>
                    <h3 style={{ marginTop: '0', color: 'var(--color-primary)' }}>Wi-Fi Credentials</h3>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <label htmlFor="wifiSSID" style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px' }}>Wi-Fi Network Name (SSID)</label>
                        <input
                            id="wifiSSID"
                            name="wifiSSID"
                            type="text"
                            value={hotelSettings.wifiSSID || ''}
                            onChange={handleChange}
                            style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}
                            placeholder="e.g., HotelGuestWifi"
                        />
                    </div>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <label htmlFor="wifiPassword" style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px' }}>Wi-Fi Password</label>
                        <input
                            id="wifiPassword"
                            name="wifiPassword"
                            type="password"
                            value={hotelSettings.wifiPassword || ''}
                            onChange={handleChange}
                            style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}
                            placeholder="********"
                        />
                    </div>
                </div>

                <div style={{ marginBottom: '30px', padding: '15px', border: '1px solid #ddd', borderRadius: '6px' }}>
                    <h3 style={{ marginTop: '0', color: 'var(--color-primary)' }}>Housekeeping Messaging</h3>
                    <p style={{ color: '#777', fontSize: '0.9em' }}>This message is sent to the guest when you click the "Notify Housekeeping" button, providing an ETA for cleaning staff.</p>
                    
                    <div style={{ marginBottom: '15px' }}>
                        <label htmlFor="housekeepingMessage" style={{ display: 'block', fontWeight: 'bold', marginBottom: '5px' }}>Housekeeping ETA Message</label>
                        <input
                            id="housekeepingMessage"
                            name="housekeepingMessage"
                            type="text"
                            value={hotelSettings.housekeepingMessage || '5 minutes'}
                            onChange={handleChange}
                            style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}
                            placeholder="e.g., '5 minutes' or '10 minutes'"
                        />
                    </div>
                </div>

                <button 
                    type="submit" 
                    disabled={loading}
                    style={{ 
                        padding: '12px 25px', 
                        backgroundColor: loading ? '#ccc' : 'var(--color-success)', 
                        color: 'white', 
                        border: 'none', 
                        borderRadius: '4px', 
                        cursor: loading ? 'not-allowed' : 'pointer',
                        fontSize: '1em',
                        transition: 'background-color 0.2s'
                    }}
                >
                    {loading ? 'Saving...' : 'Save All Settings'}
                </button>
            </form>
        </div>
    );
}